import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type AuroraOutcomeValuesProps = {
	name: string;
	value: number;
	displayName: string;
};

type GverifyAuroraOutcomeFieldMutationProps = {
	id: string;
	values: AuroraOutcomeValuesProps;
	onSuccessHandler?: Function;
};

const useGverifyAuroraOutcomeFieldMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id, values }: GverifyAuroraOutcomeFieldMutationProps) => {
			return autoChecklistService.setGVerifyGAuthenticationAuroraOutcome(
				id,
				values.name,
			);
		},
		{
			onSuccess(data, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Field has been updated successfully",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useGverifyAuroraOutcomeFieldMutation;
